<template>
  <b-container>
    <b-overlay :show="loading" no-wrap fixed />
    <b-row class="mb-3">
      <b-col>
        <h1>Create Item</h1>
      </b-col>
      <b-col>
        <b-button
          variant="primary"
          class="float-right"
          @click="$router.push('/items')"
        >
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="Object.keys(errors).length">
      <b-col class="mb-2" sm="12" :lg="!kitchenCount ? 6 : 12">
        <error-alert :errors="errors" />
      </b-col>
    </b-row>
    <b-form @submit.prevent="onCreate">
      <b-row :class="{ 'base-form': kitchenCount }">
        <b-col :cols="kitchenCount ? 12 : 6" class="mb-3">
          <div :class="{ 'base-form-col': !kitchenCount }">
            <b-row :class="{ 'no-gutters': !kitchenCount }">
              <b-col :cols="kitchenCount ? 6 : 12">
                <b-form-group label="Name">
                  <b-form-input v-model="name" />
                </b-form-group>
                <b-form-group label="Import Key">
                  <b-form-input v-model="importKey" />
                </b-form-group>
                <b-form-group label="Price">
                  <currency-input
                    v-model="price"
                    :value-as-integer="true"
                    :value-range="{
                      min: 0,
                    }"
                    class="form-control"
                  />
                </b-form-group>
                <b-form-group label="Brand">
                  <custom-search-field
                    v-model="brand"
                    :path-to-search="'brands'"
                    :query-params="{
                      id: brandIds.join(','),
                    }"
                  />
                </b-form-group>
              </b-col>
              <b-col v-if="kitchenCount" cols="6">
                <custom-search-field
                  v-model="menu"
                  :path-to-search="'menus'"
                  group-label="Menu"
                />
                <custom-search-field
                  ref="menuCategorySearch"
                  v-model="categories"
                  group-label="Categories"
                  :disabled="!menu"
                  :path-to-search="'menu-categories'"
                  :multiselect="true"
                  :query-params="categoryQueryParams"
                />
                <custom-search-field
                  v-model="kitchen"
                  :path-to-search="'fulfillment-centers'"
                  group-label="Kitchen"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button variant="primary" type="submit">Create</b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Item from '../../models/Item';

export default {
  data() {
    return {
      name: null,
      brand: null,
      price: null,
      importKey: null,
      menu: null,
      categoryQueryParams: null,
      categories: [],
      kitchen: null,
      errors: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters('session', ['kitchenCount', 'brandIds']),
    menuId() {
      return this.menu ? this.menu.id : null;
    },
  },
  watch: {
    menu: {
      immediate: true,
      handler() {
        this.onMenuChange();
      },
    },
  },
  methods: {
    // Update category filter based on applied menu filter
    onMenuChange() {
      this.categoryQueryParams = {
        menu: this.menu ? this.menu.id : null,
      };

      if (this.$refs.menuCategorySearch) {
        this.$refs.menuCategorySearch.searchItems('');
      }

      // Reset selected categories
      this.categories = [];
    },
    onCreate() {
      const me = this;
      const item = new Item({
        name: me.name,
        brand_id: me.brand ? me.brand.id : null,
        import_key: me.importKey,
        price: me.price,
      });

      if (me.kitchenCount) {
        item.set('menu_id', me.menu ? me.menu.id : -1);
        item.set('fulfillment_center_id', me.kitchen ? me.kitchen.id : -1);
        item.set(
          'menu_categories',
          me.categories.map((el) => el.id)
        );
      }

      me.loading = true;

      item
        .save()
        .then((response) => {
          const data = response.getData();

          me.$router.push({
            name: 'item',
            params: {
              id: data.id,
            },
          });
        })
        .catch((error) => {
          me.loading = false;
          me.errors = error.response.data.errors;
        });
    },
  },
};
</script>
